export default "__VITE_ASSET__CCjilKXY__"